import { Outlet } from 'react-router-dom';

const ProgramsOutlet = () => {
  return <Outlet />;
};

export default ProgramsOutlet;
